import React, { useState, useEffect } from "react";
import { engineersJobsRoute, manageJobsRoute } from "../services/routes";
import { List, ListItem, ListItemText, Divider, ListItemIcon, ListItemSecondaryAction } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { getEngineers } from "../services/user-service";
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined';
import WorkOutlineOutlinedIcon from '@material-ui/icons/WorkOutlineOutlined';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

export const Login = ({ setUser }) => {

    const [engineers, setEngineers] = useState([]);
    const history = useHistory();

    useEffect(() => { getEngineers().then((engineers) => setEngineers(engineers)) }, []);

    const viewJobManagement = () => {
        history.push(manageJobsRoute);
    }

    const viewJobs = (engineerId) => {
        history.push(engineersJobsRoute + "/" + engineerId);
    }

    return (<List>
            {engineers?.map((engineer, index) =>
                <ListItem button key={index} onClick={() => viewJobs(engineer.id)}>
                    <ListItemIcon>
                        <BuildOutlinedIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={"Jobs - " + engineer.fullName} />
                    <ListItemSecondaryAction>
                        <KeyboardArrowRightIcon />
                    </ListItemSecondaryAction>
                </ListItem>)
            }
            <Divider />
            <ListItem button onClick={() => viewJobManagement()}>
                <ListItemIcon>
                <WorkOutlineOutlinedIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="Job Management" />
                <ListItemSecondaryAction>
                    <KeyboardArrowRightIcon />
                </ListItemSecondaryAction>
            </ListItem>
        </List>);
}